import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { HttpClientModule } from '@angular/common/http';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LibModule } from '@ui-components/lib.module';
import { LibManagementGroupModalModule } from '@ui-components/management-group-modal';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { B2cAssessmentModule } from './b2c-assessment/b2c-assessment.module';
import { ForgotPasswordModule } from './forgot-password/forgot-password.module';
import { LoginModule } from './login/login.module';
import { ResetLinkConfirmationComponent } from './reset-link-confirmation/reset-link-confirmation.component';
import { ResetPasswordModule } from './reset-password/reset-password.module';


@NgModule({
  declarations: [
    AppComponent,
    ResetLinkConfirmationComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    LoginModule,
    ForgotPasswordModule,
    ResetPasswordModule,
    AppRoutingModule,
    B2cAssessmentModule,
    LibModule,
    LibManagementGroupModalModule,
  ],
  providers: [
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: {
        appearance: 'outline'
      }
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
